import type {
  LotStoryGroupDeliveryReceiptRecord,
  LotStoryGroupShareReviewPreflightRecord
} from '../../utils/api'
import type { LotStoryActorContextV1 } from '../../types/lotStory'

const normalizeLabel = (value?: string | null): string => value?.trim() || ''

const formatPresentationIdentityLabel = (args: {
  communityDisplayName?: string | null
  accountDisplayName?: string | null
}): string => {
  const communityLabel = normalizeLabel(args.communityDisplayName)
  const accountLabel = normalizeLabel(args.accountDisplayName)

  if (communityLabel && accountLabel && communityLabel !== accountLabel) {
    return `${communityLabel} (${accountLabel})`
  }

  return communityLabel || accountLabel
}

export const resolveStoredActorContextLabel = (
  recordedByContext: LotStoryGroupShareReviewPreflightRecord['reviewRecordedByContext'] | LotStoryActorContextV1 | undefined,
  currentTenantMembershipId: string | undefined,
  currentIdentityLabel: string
): string => {
  if (!recordedByContext) {
    return ''
  }

  const storedLabel = formatPresentationIdentityLabel(recordedByContext)
  if (storedLabel) {
    return storedLabel
  }

  if (
    recordedByContext.tenantMembershipId
    && recordedByContext.tenantMembershipId === currentTenantMembershipId
    && currentIdentityLabel
  ) {
    return currentIdentityLabel
  }

  return recordedByContext.actorId
    ?? recordedByContext.tenantMembershipId
    ?? recordedByContext.userId
    ?? recordedByContext.tokenId
    ?? ''
}

export const resolveGroupDeliveryReceiptViewerLabel = (
  receipt: LotStoryGroupDeliveryReceiptRecord['latestReceipt'] | undefined
): string => {
  const viewerContext = receipt?.viewerContext
  const storedLabel = formatPresentationIdentityLabel(viewerContext ?? {})

  return storedLabel
    || normalizeLabel(viewerContext?.actorId)
    || normalizeLabel(viewerContext?.tenantMembershipId)
}
